import React, { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';

import RoleRestrictedRoute from 'utility/routing/RoleRestrictedRoute';
import { roles } from 'utility/constants/roles';

const ServerProtection = lazy(
	() => import('containers/pages/security/ServerProtection'),
);

const NotFound = lazy(() => import('pages/error/NotFound'));

const SecurityRouter = () => {
	return (
		<Switch>
			<RoleRestrictedRoute
				exact
				path="/security/server-protection"
				component={ServerProtection}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<Route>
				<NotFound />
			</Route>
		</Switch>
	);
};

export default SecurityRouter;
